function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  rx: 22,
  fill: "#294E80"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M84.4143 56.7741C83.1438 55.4589 81.7631 54.6525 79.9481 54.2002C78.7133 53.8938 75.7884 53.8045 74.5297 54.0426C70.6526 54.7805 67.9658 57.2591 67.207 60.8207C66.9928 61.8383 67.0612 64.3675 67.332 65.3762C67.7173 66.6952 68.3866 67.9139 69.2928 68.9468C70.7449 70.5119 72.3308 71.4968 76.0145 73.0827C79.234 74.4812 80.3676 75.1477 80.9211 75.9392C81.3525 76.5641 81.4567 76.9271 81.4567 77.7543C81.4772 78.159 81.4038 78.563 81.2422 78.9347C81.0806 79.3063 80.8353 79.6356 80.5253 79.8966C78.984 81.2802 75.8568 81.4498 73.5776 80.2477C72.7831 79.8282 71.4709 78.5696 70.8699 77.6531L70.4384 77.0164L68.3853 78.2066C67.2517 78.8641 66.0525 79.5574 65.7312 79.7389C65.5018 79.8605 65.2828 80.0008 65.0766 80.1585C64.9962 80.2924 66.2787 82.1878 66.9363 82.9108C68.6144 84.7705 71.334 86.1868 74.2024 86.6986C75.5176 86.9367 78.4187 86.9694 79.6416 86.7522C83.599 86.0857 86.4109 84.0683 87.5416 81.0987C88.5741 78.3672 88.2319 74.6925 86.7144 72.3924C85.3546 70.3304 83.1676 68.8814 78.0527 66.6795C75.2795 65.4804 74.3928 64.8882 73.9168 63.9033C73.6983 63.492 73.5935 63.0297 73.6133 62.5644C73.6014 60.672 74.9939 59.5383 77.1601 59.6871C78.6329 59.7882 79.594 60.3655 80.5164 61.7045C80.8199 62.1567 81.0937 62.4513 81.1621 62.4067C83.0426 61.2373 86.149 59.1545 86.1252 59.0652C86.0479 58.7557 85.0719 57.4763 84.4143 56.7741Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M63.208 60.1066L63.1841 57.1817L63.1514 54.2687L50.6692 54.233C43.8137 54.2211 38.1573 54.2449 38.1216 54.2925C38.0769 54.3222 38.0442 55.6493 38.0442 57.2382V60.1066H47.3337V86.5171H53.9095V60.1066H63.208Z",
  fill: "white"
});

function SvgTs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs);
export default __webpack_public_path__ + "static/media/ts.523ed1bd.svg";
export { ForwardRef as ReactComponent };